/**
 * Crafted Dark Glass — product page interactions.
 * Config: window.CraftedDarkGlassPdp { bundleSize, bundleTargetCents, freeShipCents, bundleSaveCents, offers[] }
 * bust: 2026-08-07-sticky-price-v1
 */
(function () {
  'use strict';

  var STICKY_MOBILE_MQ = '(max-width: 959px)';

  function getConfig() {
    return window.CraftedDarkGlassPdp || {};
  }

  function moneyFromCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function initPdp() {
    var root = document.querySelector('.dg-pdp');
    if (!root || root.dataset.dgInitialized === 'true') return;
    root.dataset.dgInitialized = 'true';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var buyBox = root.querySelector('#dgPdpBuyBox');
    /* Sticky bar is a sibling of .dg-pdp (inside product-info) so fixed positioning is not clipped */
    var pdpHost = root.closest('product-info') || root.closest('.dg-pdp-section') || root.parentElement || document;
    var stickyAtc =
      root.querySelector('.dg-sticky-atc') ||
      (pdpHost && pdpHost.querySelector && pdpHost.querySelector('.dg-sticky-atc')) ||
      document.querySelector('.dg-sticky-atc');
    var stickyTitle = stickyAtc && stickyAtc.querySelector('[data-dg-sticky-title]');
    var stickyPrice = stickyAtc && stickyAtc.querySelector('[data-dg-sticky-price]');
    var stickyBuy = stickyAtc && stickyAtc.querySelector('[data-dg-sticky-buy]');
    var stickyThumb = stickyAtc && stickyAtc.querySelector('[data-dg-sticky-thumb]');

    function ensureStickyPriceStructure() {
      if (!stickyPrice) return { currentEl: null, compareEl: null };
      var currentEl = stickyPrice.querySelector('[data-dg-sticky-current]');
      var compareEl = stickyPrice.querySelector('[data-dg-sticky-compare]');
      if (!currentEl) {
        stickyPrice.textContent = '';
        currentEl = document.createElement('span');
        currentEl.className = 'sticky-atc__current';
        currentEl.setAttribute('data-dg-sticky-current', '');
        stickyPrice.appendChild(currentEl);
      }
      if (!compareEl) {
        compareEl = document.createElement('s');
        compareEl.className = 'sticky-atc__compare';
        compareEl.setAttribute('data-dg-sticky-compare', '');
        compareEl.hidden = true;
        stickyPrice.appendChild(compareEl);
      }
      return { currentEl: currentEl, compareEl: compareEl };
    }

    function formatStickyMoney(cents) {
      if (cents == null || cents === '') return '';
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try {
          return Shopify.formatMoney(cents);
        } catch (e) {
          /* fall through */
        }
      }
      var n = Number(cents);
      if (!isFinite(n)) return String(cents);
      return '$' + (n / 100).toFixed(2);
    }

    function setStickyPrice(current, compare) {
      if (!stickyPrice) return;
      var parts = ensureStickyPriceStructure();
      if (parts.currentEl && current) parts.currentEl.textContent = current;
      if (!parts.compareEl) return;
      if (compare) {
        parts.compareEl.textContent = compare;
        parts.compareEl.hidden = false;
        parts.compareEl.removeAttribute('hidden');
      } else {
        parts.compareEl.textContent = '';
        parts.compareEl.hidden = true;
      }
    }

    function syncStickyPriceFromHero() {
      if (!heroPrice || !stickyPrice) return;
      var heroCurrent = heroPrice.querySelector('span:not(.hero__save)');
      var heroCompare = heroPrice.querySelector('s');
      setStickyPrice(
        heroCurrent ? heroCurrent.textContent.trim() : '',
        heroCompare ? heroCompare.textContent.trim() : ''
      );
    }
    var mainImage = root.querySelector('[data-dg-main-image]');
    var galleryMain = root.querySelector('[data-dg-gallery-main]');
    var productForm = root.querySelector('form[action*="/cart/add"]');
    var variantInput = productForm && productForm.querySelector('input[name="id"]');
    var heroPrice = root.querySelector('[data-dg-hero-price]');
    var ritualBar = root.querySelector('.dg-ritual-progress span, .dg-ritual-progress__bar, [data-dg-ritual-bar]');
    var doneSteps = new Set();
    var stickyMobileMq =
      typeof window.matchMedia === 'function' ? window.matchMedia(STICKY_MOBILE_MQ) : null;

    /* —— Gallery thumbs —— */
    function setMainImage(src, alt, mediaId) {
      if (!mainImage || !src) return;
      if (galleryMain) galleryMain.classList.add('is-swapping');
      window.setTimeout(function () {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = src;
        if (alt) mainImage.alt = alt;
        if (mediaId != null && mediaId !== '') {
          mainImage.setAttribute('data-media-id', String(mediaId));
        }
        if (stickyThumb) {
          stickyThumb.removeAttribute('srcset');
          stickyThumb.src = src;
        }
        if (galleryMain) galleryMain.classList.remove('is-swapping');
      }, 160);
    }

    var thumbButtons = Array.prototype.slice.call(root.querySelectorAll('[data-dg-thumb]'));

    function activateThumb(btn, scrollIntoView) {
      if (!btn) return;
      thumbButtons.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');
      var src = btn.getAttribute('data-src') || btn.dataset.dgSrc || btn.dataset.src;
      var alt = btn.getAttribute('aria-label') || '';
      var mediaId = btn.getAttribute('data-media-id') || '';
      if (src) setMainImage(src, alt, mediaId);
      if (scrollIntoView && thumbTrack) {
        btn.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    }

    thumbButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateThumb(btn, false);
      });
    });

    function stepGallery(dir) {
      if (!thumbButtons.length) return;
      var current = thumbButtons.findIndex(function (t) {
        return t.classList.contains('is-active');
      });
      if (current < 0) current = 0;
      var next = (current + dir + thumbButtons.length) % thumbButtons.length;
      activateThumb(thumbButtons[next], true);
    }

    /* Thumb strip scroll controls */
    var thumbTrack = root.querySelector('[data-dg-thumbs]');
    var thumbPrev = root.querySelector('[data-dg-thumbs-prev]');
    var thumbNext = root.querySelector('[data-dg-thumbs-next]');
    var mainPrev = root.querySelector('[data-dg-main-prev]');
    var mainNext = root.querySelector('[data-dg-main-next]');
    function scrollThumbs(dir) {
      if (!thumbTrack) return;
      thumbTrack.scrollBy({ left: dir * Math.max(160, thumbTrack.clientWidth * 0.7), behavior: 'smooth' });
    }
    if (thumbPrev) thumbPrev.addEventListener('click', function () { scrollThumbs(-1); });
    if (thumbNext) thumbNext.addEventListener('click', function () { scrollThumbs(1); });
    if (mainPrev) mainPrev.addEventListener('click', function () { stepGallery(-1); });
    if (mainNext) mainNext.addEventListener('click', function () { stepGallery(1); });

    /* Scent → main image (beard oil / balm / oil+balm) */
    var variantMediaMap = {};
    var variantMediaEl = root.querySelector('[data-dg-variant-media]');
    var enableVariantGallery =
      (root.getAttribute('data-dg-scent-gallery') === 'true' || root.classList.contains('dg-pdp--oil')) &&
      !!variantMediaEl;
    if (variantMediaEl) {
      try {
        variantMediaMap = JSON.parse(variantMediaEl.textContent || '{}');
      } catch (e) {
        variantMediaMap = {};
      }
    }

    function findThumbForMedia(media) {
      if (!media) return null;
      if (media.mediaId != null) {
        var byId = thumbButtons.find(function (btn) {
          return String(btn.getAttribute('data-media-id')) === String(media.mediaId);
        });
        if (byId) return byId;
      }
      if (media.src) {
        var bySrc = thumbButtons.find(function (btn) {
          var src = btn.getAttribute('data-src') || '';
          return src && media.src && src.split('?')[0] === media.src.split('?')[0];
        });
        if (bySrc) return bySrc;
      }
      if (media.title) {
        var title = String(media.title).toLowerCase();
        return thumbButtons.find(function (btn) {
          var label = (btn.getAttribute('aria-label') || '').toLowerCase();
          return label && title && label.indexOf(title) !== -1;
        }) || null;
      }
      return null;
    }

    function syncGalleryFromVariant(variantId) {
      if (!enableVariantGallery) return;
      var id = variantId || (variantInput && variantInput.value);
      if (!id) return;
      var media = variantMediaMap[String(id)];
      if (!media || !media.src) return;

      var match = findThumbForMedia(media);
      if (match) {
        activateThumb(match, true);
      } else {
        setMainImage(media.src, media.alt || '', media.mediaId);
      }
    }

    /* Ensure quantity defaults to 1 */
    var qtyInput = root.querySelector('.dg-qty-input, input[name="quantity"]');
    if (qtyInput && (!qtyInput.value || Number(qtyInput.value) < 1)) {
      qtyInput.value = '1';
    }

    /* —— Sticky ATC (mobile only) —— */
    var stickyBuyBoxVisible = true;
    var stickyFooterVisible = false;
    var stickyDefaultLabel = (function () {
      var label = stickyBuy && stickyBuy.querySelector('.glow-btn__glass');
      return label ? label.textContent.trim() : 'Buy Now';
    })();
    var stickyUnavailableLabel = root.querySelector('.dg-scents, [data-dg-scent-gallery], [data-dg-oil-root]')
      ? 'Choose another scent'
      : 'Unavailable';

    function isStickyMobile() {
      return stickyMobileMq ? stickyMobileMq.matches : window.innerWidth <= 959;
    }

    function updateStickyVisibility() {
      if (!stickyAtc) return;
      var show = isStickyMobile() && !stickyBuyBoxVisible && !stickyFooterVisible;
      stickyAtc.classList.toggle('is-visible', show);
      stickyAtc.classList.toggle('is-footer-hidden', stickyFooterVisible || !isStickyMobile());
      stickyAtc.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('dg-sticky-active', show);
    }

    function getOilVariantMap() {
      var oilRoot = document.querySelector('[data-dg-oil-root]');
      var dataEl = oilRoot && oilRoot.querySelector('[data-dg-oil-variants]');
      if (!dataEl) dataEl = root.querySelector('[data-dg-variants]');
      if (!dataEl) return {};
      try {
        return JSON.parse(dataEl.textContent || '{}');
      } catch (e) {
        return {};
      }
    }

    function syncStickyFromVariant() {
      if (!variantInput) return;
      var variantId = variantInput.value;
      if (!variantId) return;

      var variants = getOilVariantMap();
      var display = variants[variantId];
      var available = true;
      if (display) {
        if (display.price) setStickyPrice(display.price, display.compare || '');
        available = display.available !== false;
      } else if (heroPrice && stickyPrice) {
        syncStickyPriceFromHero();
      }

      var submit = productForm && productForm.querySelector('[type="submit"], button[name="add"]');
      if (submit) available = !submit.disabled && available;

      var titleEl = root.querySelector('[data-dg-product-title], h1.display, h1');
      if (stickyTitle) {
        stickyTitle.textContent = titleEl ? titleEl.textContent.trim() : 'Crafted Beard Oil';
      }

      if (stickyAtc) stickyAtc.classList.toggle('is-unavailable', !available);
      if (stickyBuy) {
        stickyBuy.disabled = false;
        stickyBuy.setAttribute('data-dg-oil-available', available ? 'true' : 'false');
        var stickyLabel = stickyBuy.querySelector('.glow-btn__glass');
        if (stickyLabel) {
          stickyLabel.textContent = available ? stickyDefaultLabel : stickyUnavailableLabel;
        }
      }

      document.dispatchEvent(
        new CustomEvent('dg:oil-variant-sync', {
          detail: {
            variantId: variantId,
            available: available,
            price: display && display.price ? display.price : stickyPrice ? stickyPrice.textContent.trim() : '',
            title: display && display.title ? display.title : ''
          }
        })
      );
    }

    var stickyAnchor =
      (productForm && productForm.querySelector('.dg-atc-btn, [type="submit"], button[name="add"]')) || buyBox;
    if (stickyAnchor && stickyAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyBuyBoxVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        { threshold: 0, rootMargin: '0px 0px -8% 0px' }
      ).observe(stickyAnchor);
    } else if (stickyAnchor && stickyAtc) {
      stickyBuyBoxVisible = (function () {
        var r = stickyAnchor.getBoundingClientRect();
        return r.bottom > 0 && r.top < window.innerHeight;
      })();
    }

    var footer = document.querySelector('footer, .footer, #shopify-section-footer, .shopify-section-group-footer-group');
    if (footer && stickyAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyFooterVisible = entry.isIntersecting;
            updateStickyVisibility();
          });
        },
        { threshold: 0.01, rootMargin: '0px 0px -8% 0px' }
      ).observe(footer);
    }

    if (stickyMobileMq) {
      if (typeof stickyMobileMq.addEventListener === 'function') {
        stickyMobileMq.addEventListener('change', updateStickyVisibility);
      } else if (typeof stickyMobileMq.addListener === 'function') {
        stickyMobileMq.addListener(updateStickyVisibility);
      }
    }
    updateStickyVisibility();

    if (stickyBuy && productForm) {
      stickyBuy.addEventListener('click', function (event) {
        event.preventDefault();
        var available = stickyBuy.getAttribute('data-dg-oil-available') !== 'false';
        if (!available) {
          focusVariantSelector();
          return;
        }
        var submit = productForm.querySelector('[type="submit"], button[name="add"]');
        if (submit && !submit.disabled) submit.click();
      });
    }

    function focusVariantSelector() {
      var target =
        root.querySelector('#variant-selects-' + (root.dataset.sectionId || '')) ||
        root.querySelector('variant-selects') ||
        root.querySelector('.dg-scents') ||
        buyBox;
      if (!target) return;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      var focusable =
        target.querySelector('input[type="radio"]:not(:disabled), button:not(:disabled), [tabindex]') || target;
      if (focusable && typeof focusable.focus === 'function') {
        try {
          focusable.focus({ preventScroll: true });
        } catch (e) {
          focusable.focus();
        }
      }
    }

    window.CraftedDarkGlassPdp.focusVariantSelector = focusVariantSelector;

    variantInput && variantInput.addEventListener('change', function () {
      syncStickyFromVariant();
      syncGalleryFromVariant(variantInput.value);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var detail = event && event.data;
        if (!detail || !detail.variant) return;
        if (stickyPrice && detail.variant.price != null) {
          var formatted =
            detail.variant.price_formatted ||
            formatStickyMoney(detail.variant.price);
          var compareFormatted = '';
          if (detail.variant.compare_at_price > detail.variant.price) {
            compareFormatted =
              detail.variant.compare_at_price_formatted ||
              formatStickyMoney(detail.variant.compare_at_price);
          }
          if (formatted) setStickyPrice(formatted, compareFormatted);
        }
        window.setTimeout(function () {
          syncStickyFromVariant();
          syncGalleryFromVariant(detail.variant.id);
        }, 0);
      });
    }

    root.querySelectorAll('[data-dg-option], .dg-scent, .dg-scents label, .dg-scents input[type="radio"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.setTimeout(function () {
          syncStickyFromVariant();
          syncGalleryFromVariant();
        }, 0);
      });
      btn.addEventListener('change', function () {
        window.setTimeout(function () {
          syncStickyFromVariant();
          syncGalleryFromVariant();
        }, 0);
      });
    });

    syncStickyFromVariant();
    syncGalleryFromVariant();

    /* —— Quantity —— */
    var qtyInput = root.querySelector('.dg-qty-input');
    root.querySelectorAll('[data-dg-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    });
    root.querySelectorAll('[data-dg-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    });

    /* —— Ingredient chips —— */
    root.querySelectorAll('.ing-mosaic .chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var open = chip.classList.contains('is-open');
        root.querySelectorAll('.ing-mosaic .chip').forEach(function (c) {
          c.classList.remove('is-open');
        });
        if (!open) chip.classList.add('is-open');
      });
    });

    /* —— FAQ accordion inside hero root —— */
    root.querySelectorAll('.dg-faq').forEach(function (item) {
      item.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        root.querySelectorAll('.dg-faq').forEach(function (f) {
          f.classList.remove('is-open');
        });
        if (!open) item.classList.add('is-open');
      });
    });

    /* —— Benefit cards —— */
    root.querySelectorAll('.dg-benefit').forEach(function (card) {
      card.addEventListener('click', function () {
        var open = card.classList.contains('is-open');
        root.querySelectorAll('.dg-benefit').forEach(function (c) {
          c.classList.remove('is-open');
        });
        if (!open) card.classList.add('is-open');
      });
    });

    /* —— Ritual steps —— */
    root.querySelectorAll('.dg-step').forEach(function (step) {
      step.addEventListener('click', function () {
        var id = step.dataset.step || step.getAttribute('data-step');
        step.classList.toggle('is-done');
        step.classList.add('is-active');
        if (step.classList.contains('is-done')) doneSteps.add(id);
        else doneSteps.delete(id);
        var total = root.querySelectorAll('.dg-step').length;
        if (ritualBar) ritualBar.style.width = ((doneSteps.size / total) * 100) + '%';
      });
    });

    /* —— Gallery tilt (desktop fine pointer only — avoid mobile drag/shift) —— */
    if (
      !reduceMotion &&
      galleryMain &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches
    ) {
      galleryMain.addEventListener('pointermove', function (e) {
        var rect = galleryMain.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        galleryMain.style.transform =
          'rotateX(' + ((0.5 - y) * 8) + 'deg) rotateY(' + ((x - 0.5) * 12) + 'deg)';
      });
      galleryMain.addEventListener('pointerleave', function () {
        galleryMain.style.transform = 'rotateX(0) rotateY(0)';
      });
    }

    /* —— Bundle drawer (grooming oils/balms only) —— */
    var bundleSection = root.dataset.dgBundle === 'true' ? root : null;
    if (bundleSection) {
      initBundleDrawer(root, bundleSection, productForm, variantInput, getConfig());
    }

    /* —— Softener BOGO: pick a free Beard Oil scent —— */
    if (root.dataset.dgBogo === 'true') {
      initBogoDrawer(root, productForm, variantInput);
    }

    /* —— Kit upgrade drawer (serum → growth kit) —— */
    if (root.dataset.dgKitUpgrade === 'true') {
      initKitUpgradeDrawer(root, productForm, variantInput);
    }

    if (window.CraftedMotion && typeof window.CraftedMotion.init === 'function') {
      window.CraftedMotion.init();
    }
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  }

  function addVariantToCart(variantId, quantity) {
    var payload = {
      items: [{ id: Number(variantId), quantity: quantity || 1 }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    });
  }

  function openThemeCartDrawer(parsedState) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && parsedState && parsedState.sections) {
      drawer.renderContents(parsedState);
      document.dispatchEvent(new CustomEvent('cart:update'));
      return true;
    }
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      document.dispatchEvent(new CustomEvent('cart:update'));
      return true;
    }
    document.dispatchEvent(new CustomEvent('cart:update'));
    return false;
  }

  function initKitUpgradeDrawer(root, productForm, variantInput) {
    var host = root.closest('product-info') || root.parentElement || document;
    var drawer = host.querySelector('[data-dg-upgrade-drawer]');
    var scrim = host.querySelector('[data-dg-upgrade-scrim]');
    var closeBtn = host.querySelector('[data-dg-upgrade-close]');
    var confirmBtns = host.querySelectorAll('[data-dg-upgrade-confirm]');
    var declineBtns = host.querySelectorAll('[data-dg-upgrade-decline]');
    var configNode = host.querySelector('[data-dg-upgrade-config]');
    if (!drawer || !configNode) return;

    var cfg = {};
    try {
      cfg = JSON.parse(configNode.textContent || '{}');
    } catch (e) {
      cfg = {};
    }

    var busy = false;

    function openUpgrade() {
      if (scrim) {
        scrim.hidden = false;
        requestAnimationFrame(function () {
          scrim.classList.add('is-open');
        });
      }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeUpgrade() {
      if (scrim) scrim.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (scrim) {
        window.setTimeout(function () {
          scrim.hidden = true;
        }, 320);
      }
    }

    function currentQty() {
      var qtyInput = productForm && productForm.querySelector('input[name="quantity"]');
      return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }

    function currentBaseVariantId() {
      if (variantInput && variantInput.value) return variantInput.value;
      return cfg.baseVariantId || cfg.serumVariantId;
    }

    function setBusy(isBusy) {
      busy = isBusy;
      confirmBtns.forEach(function (btn) {
        btn.disabled = isBusy || cfg.kitAvailable === false;
      });
      declineBtns.forEach(function (btn) {
        btn.disabled = isBusy;
      });
    }

    function checkoutUrl() {
      return (window.routes && window.routes.cart_url ? window.routes.cart_url.replace(/\/cart\/?$/, '/checkout') : null) || '/checkout';
    }

    function afterAddToCart(parsedState) {
      closeUpgrade();
      if (!openThemeCartDrawer(parsedState)) {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    }

    function afterAddToCheckout() {
      closeUpgrade();
      window.location.href = checkoutUrl();
    }

    if (productForm) {
      productForm.addEventListener(
        'submit',
        function (event) {
          if (busy) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          openUpgrade();
        },
        true
      );
    }

    if (closeBtn) closeBtn.addEventListener('click', closeUpgrade);
    if (scrim) scrim.addEventListener('click', closeUpgrade);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeUpgrade();
    });

    confirmBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (busy || !cfg.kitVariantId) return;
        setBusy(true);
        addVariantToCart(cfg.kitVariantId, currentQty())
          .then(afterAddToCheckout)
          .catch(function (err) {
            console.error('[CraftedDarkGlassPdp] kit upgrade failed', err);
            setBusy(false);
            window.location.href = '/products/beard-growth-kit';
          });
      });
    });

    declineBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (busy) return;
        var baseId = currentBaseVariantId();
        if (!baseId) return;
        setBusy(true);
        addVariantToCart(baseId, currentQty())
          .then(afterAddToCart)
          .catch(function (err) {
            console.error('[CraftedDarkGlassPdp] base product add failed', err);
            setBusy(false);
            if (productForm) productForm.submit();
          });
      });
    });
  }

  function initBundleDrawer(root, bundleSection, productForm, variantInput, cfg) {
    var host = root.closest('product-info') || root.parentElement || document;
    var configNode =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-config]')) ||
      host.querySelector('[data-dg-bundle-config]') ||
      document.querySelector('[data-dg-bundle-config]');
    if (configNode) {
      try {
        cfg = Object.assign({}, cfg || {}, JSON.parse(configNode.textContent || '{}'));
      } catch (e) {
        /* keep passed cfg */
      }
    }

    var BUNDLE_SIZE = cfg.bundleSize || 3;
    var BUNDLE_TARGET = cfg.bundleTargetCents || 2200;
    var FREE_SHIP = cfg.freeShipCents || 2000;
    var BUNDLE_SAVE = cfg.bundleSaveCents || 500;
    var offers = Array.isArray(cfg.offers) ? cfg.offers : [];
    var unitPrice = offers.length ? offers[0].price || 900 : 900;

    var bundleItems = [];
    var bundleDrawer =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-drawer]')) ||
      host.querySelector('[data-dg-bundle-drawer]') ||
      document.getElementById('dgBundleDrawer');
    var bundleScrim =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-scrim]')) ||
      host.querySelector('[data-dg-bundle-scrim]') ||
      document.getElementById('dgBundleScrim');
    var bundleCart =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-cart]')) ||
      host.querySelector('[data-dg-bundle-cart]');
    var bundleOils =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-oils]')) ||
      host.querySelector('[data-dg-bundle-oils]');
    var bundleBalms =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-balms]')) ||
      host.querySelector('[data-dg-bundle-balms]');
    var bundleCount =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-count]')) ||
      host.querySelector('[data-dg-bundle-count]');
    var bundleBar =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-bar]')) ||
      host.querySelector('[data-dg-bundle-bar]');
    var bundleHint =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-hint]')) ||
      host.querySelector('[data-dg-bundle-hint]');
    var bundleProgress =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-progress]')) ||
      host.querySelector('[data-dg-bundle-progress]');
    var bundleSub =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-sub]')) ||
      host.querySelector('[data-dg-bundle-sub]');
    var bundleSaveRow =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-save-row]')) ||
      host.querySelector('[data-dg-bundle-save-row]');
    var bundleTotal =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-total]')) ||
      host.querySelector('[data-dg-bundle-total]');
    var bundleCompare =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-compare]')) ||
      host.querySelector('[data-dg-bundle-compare]');
    var bundleShip =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-ship]')) ||
      host.querySelector('[data-dg-bundle-ship]');
    var bundleCheckout =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-checkout]')) ||
      host.querySelector('[data-dg-bundle-checkout]');
    var bundleSkip =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-skip]')) ||
      host.querySelector('[data-dg-bundle-skip]');
    var bundlePick =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-pick]')) ||
      host.querySelector('[data-dg-bundle-pick]');
    var bundleClose =
      (bundleSection && bundleSection.querySelector('[data-dg-bundle-close]')) ||
      host.querySelector('[data-dg-bundle-close]');

    if (!bundleDrawer) return;

    function money(cents) {
      return moneyFromCents(cents);
    }

    function findOfferByVariantId(variantId) {
      return offers.find(function (o) {
        return String(o.variantId) === String(variantId);
      });
    }

    function openBundle() {
      if (!bundleScrim) bundleScrim = bundleDrawer.previousElementSibling;
      if (bundleScrim) {
        bundleScrim.hidden = false;
        requestAnimationFrame(function () {
          bundleScrim.classList.add('is-open');
        });
      }
      bundleDrawer.classList.add('is-open');
      bundleDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      renderBundle();
    }

    function closeBundle() {
      if (bundleScrim) bundleScrim.classList.remove('is-open');
      bundleDrawer.classList.remove('is-open');
      bundleDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (bundleScrim) {
        window.setTimeout(function () {
          bundleScrim.hidden = true;
        }, 320);
      }
    }

    function offerScent(offer) {
      var scent = offer.scent || offer.title || '';
      if (!scent || scent === 'Default Title') {
        return offer.productTitle || 'Classic';
      }
      return scent;
    }

    function offerTypeLabel(type, productTitle) {
      var t = String(type || '').toLowerCase();
      if (t === 'balm') return 'Beard Balm';
      if (t === 'oil') return 'Beard Oil';
      return productTitle || 'Product';
    }

    function offerDisplayName(offer) {
      var scent = offerScent(offer);
      var typeLabel = offerTypeLabel(offer.type, offer.productTitle);
      if (scent && typeLabel && scent !== typeLabel) {
        return scent + ' · ' + typeLabel;
      }
      return scent || typeLabel || 'Product';
    }

    function addOfferToBundle(offer, alreadyInCart, isOriginal) {
      if (bundleItems.length >= BUNDLE_SIZE) return;
      bundleItems.push({
        id: offer.id || 'item-' + Date.now(),
        variantId: offer.variantId,
        type: offer.type || 'oil',
        typeLabel: offerTypeLabel(offer.type, offer.productTitle),
        scent: offerScent(offer),
        name: offerDisplayName(offer),
        img: offer.image || '',
        price: offer.price || unitPrice,
        alreadyInCart: !!alreadyInCart,
        isOriginal: !!isOriginal
      });
      renderBundle();
    }

    function renderOffers() {
      if (!bundleOils && !bundleBalms) return;

      function makeBtn(offer) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bundle-item glass glow-target dg-bundle-item';
        btn.innerHTML =
          (offer.image
            ? '<img class="bundle-item__img" src="' + offer.image + '" alt="" loading="lazy" decoding="async" />'
            : '<span class="bundle-item__img bundle-item__img--empty" aria-hidden="true"></span>') +
          '<span class="bundle-item__copy">' +
          '<span class="bundle-item__type">' +
          offerTypeLabel(offer.type, offer.productTitle) +
          '</span>' +
          '<strong class="bundle-item__scent">' +
          offerScent(offer) +
          '</strong>' +
          '</span>' +
          '<em class="bundle-item__price">' +
          money(offer.price || unitPrice) +
          '</em>';
        btn.addEventListener('click', function () {
          if (bundleItems.length >= BUNDLE_SIZE) return;
          addOfferToBundle(offer, false, false);
        });
        return btn;
      }

      if (bundleOils) {
        bundleOils.innerHTML = '';
        offers.filter(function (o) {
          return o.type === 'oil';
        }).forEach(function (o) {
          bundleOils.appendChild(makeBtn(o));
        });
      }
      if (bundleBalms) {
        bundleBalms.innerHTML = '';
        offers.filter(function (o) {
          return o.type === 'balm';
        }).forEach(function (o) {
          bundleBalms.appendChild(makeBtn(o));
        });
      }
    }

    function renderBundle() {
      var n = bundleItems.length;
      var remaining = Math.max(0, BUNDLE_SIZE - n);
      var complete = n >= BUNDLE_SIZE;
      var listSub = bundleItems.reduce(function (sum, item) {
        return sum + (item.price || unitPrice);
      }, 0);
      var total = complete ? BUNDLE_TARGET : listSub;

      if (bundleCount) bundleCount.textContent = String(Math.min(n, BUNDLE_SIZE));
      /* Exact thirds: 1 item = 33.333%, 2 = 66.666%, 3 = 100% */
      var filled = Math.min(n, BUNDLE_SIZE);
      var progressPct = BUNDLE_SIZE > 0 ? (filled / BUNDLE_SIZE) * 100 : 0;
      if (bundleProgress) {
        bundleProgress.style.setProperty('--bundle-progress', progressPct + '%');
        bundleProgress.setAttribute('data-count', String(filled));
        bundleProgress.classList.toggle('is-complete', complete);
      }
      if (bundleBar) {
        bundleBar.style.display = 'block';
        bundleBar.style.width = progressPct + '%';
      }

      if (bundleHint) {
        if (complete) {
          bundleHint.textContent =
            'Bundle unlocked — ' + money(BUNDLE_TARGET) + ' total + free U.S. shipping.';
        } else if (n === 0) {
          bundleHint.textContent =
            'Add ' +
            BUNDLE_SIZE +
            ' oils or balms to unlock ' +
            money(BUNDLE_TARGET) +
            ' and free shipping.';
        } else {
          bundleHint.textContent =
            'Add ' +
            remaining +
            ' more oil' +
            (remaining === 1 ? '' : 's') +
            ' or balm' +
            (remaining === 1 ? '' : 's') +
            ' to unlock ' +
            money(BUNDLE_TARGET) +
            ' and free shipping.';
        }
      }

      if (bundleCart) {
        bundleCart.innerHTML = '';
        if (!n) {
          bundleCart.innerHTML =
            '<p style="margin:0;color:var(--faint, rgba(247,242,234,0.42));font-size:0.88rem;">Nothing in the bundle yet.</p>';
        } else {
          bundleItems.forEach(function (item, idx) {
            var row = document.createElement('div');
            row.className = 'bundle-line glass dg-bundle-line';
            row.innerHTML =
              (item.img
                ? '<img class="bundle-line__img" src="' + item.img + '" alt="" loading="lazy" decoding="async" />'
                : '<span class="bundle-line__img bundle-line__img--empty" aria-hidden="true"></span>') +
              '<div class="bundle-line__copy">' +
              '<strong class="bundle-line__scent">' +
              (item.scent || item.name) +
              '</strong>' +
              '<span class="bundle-line__type">' +
              (item.typeLabel || offerTypeLabel(item.type)) +
              '</span>' +
              '</div>' +
              '<div class="bundle-line__price">' +
              money(item.price || unitPrice) +
              '</div>';
            row.title = 'Click to remove';
            row.style.cursor = 'pointer';
            row.addEventListener('click', function () {
              bundleItems.splice(idx, 1);
              renderBundle();
            });
            bundleCart.appendChild(row);
          });
        }
      }

      if (bundleSub) bundleSub.textContent = money(listSub);
      if (bundleSaveRow) bundleSaveRow.hidden = !complete;
      if (bundleTotal) {
        if (complete) {
          bundleTotal.innerHTML = '<s>' + money(listSub) + '</s>' + money(total);
        } else {
          bundleTotal.textContent = money(total);
        }
      }
      if (bundleCompare) bundleCompare.hidden = !complete;

      if (bundleShip) {
        if (complete || total >= FREE_SHIP) {
          bundleShip.textContent = 'Free U.S. shipping unlocked ($' + (FREE_SHIP / 100).toFixed(0) + '+).';
          bundleShip.classList.add('is-free');
        } else {
          bundleShip.textContent =
            'Add more to reach $' +
            (FREE_SHIP / 100).toFixed(0) +
            ' for free U.S. shipping (you\u2019re at ' +
            money(total) +
            ').';
          bundleShip.classList.remove('is-free');
        }
      }

      if (bundlePick) bundlePick.style.display = complete ? 'none' : '';
      bundleSection.querySelectorAll('.dg-bundle-item').forEach(function (b) {
        b.disabled = complete;
      });

      if (bundleCheckout) {
        var checkoutLabel = bundleCheckout.querySelector('.glow-btn__glass');
        if (complete) {
          bundleCheckout.disabled = false;
          if (checkoutLabel) checkoutLabel.textContent = 'Buy Now';
        } else {
          bundleCheckout.disabled = true;
          if (checkoutLabel) {
            checkoutLabel.textContent =
              'Add ' + remaining + ' more · unlock ' + money(BUNDLE_TARGET);
          }
        }
      }

      if (bundleSkip) {
        bundleSkip.disabled = n < 1;
        bundleSkip.hidden = complete;
      }
    }

    function cartAddUrl() {
      return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    }

    function addVariantToCartLocal(variantId, quantity) {
      return addVariantToCart(variantId, quantity);
    }

    function cartPageUrl() {
      return (window.routes && window.routes.cart_url) || '/cart';
    }

    function checkoutUrl() {
      return (window.routes && window.routes.cart_url
        ? window.routes.cart_url.replace(/\/cart\/?$/, '/checkout')
        : null) || '/checkout';
    }

    function cartJsonUrl() {
      return ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    }

    function cartChangeUrl() {
      return (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    }

    function addPendingBundleItems() {
      var toAdd = bundleItems.filter(function (item) {
        return !item.alreadyInCart && item.variantId;
      });
      var lastState = null;
      var chain = Promise.resolve();
      toAdd.forEach(function (item) {
        chain = chain.then(function () {
          return addVariantToCartLocal(item.variantId, 1).then(function (state) {
            lastState = state;
            item.alreadyInCart = true;
            return state;
          });
        });
      });
      return chain.then(function () {
        return lastState;
      });
    }

    /* Skip: keep only the original ATC item(s); drop extras from cart + memory */
    function skipToOriginalCartOnly() {
      var extras = bundleItems.filter(function (item) {
        return !item.isOriginal && item.variantId;
      });
      var removeCounts = {};
      extras.forEach(function (item) {
        /* Only strip lines that were actually carted as bundle extras */
        if (!item.alreadyInCart) return;
        var id = String(item.variantId);
        removeCounts[id] = (removeCounts[id] || 0) + 1;
      });

      bundleItems = bundleItems.filter(function (item) {
        return item.isOriginal;
      });

      var variantIds = Object.keys(removeCounts);
      if (!variantIds.length) return Promise.resolve();

      return fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart fetch failed');
          return res.json();
        })
        .then(function (cart) {
          var chain = Promise.resolve();
          variantIds.forEach(function (variantId) {
            var need = removeCounts[variantId];
            chain = chain.then(function () {
              var items = (cart && cart.items) || [];
              var line = null;
              for (var i = 0; i < items.length; i++) {
                if (String(items[i].variant_id) === variantId || String(items[i].id) === variantId) {
                  line = items[i];
                  break;
                }
              }
              if (!line || !need) return null;
              var nextQty = Math.max(0, (line.quantity || 0) - need);
              return fetch(cartChangeUrl(), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                body: JSON.stringify({
                  id: line.key || line.id,
                  quantity: nextQty
                })
              }).then(function (res) {
                if (!res.ok) throw new Error('Cart change failed');
                return res.json();
              }).then(function (updated) {
                cart = updated;
                return updated;
              });
            });
          });
          return chain;
        });
    }

    function flashAddedButtons() {
      root.querySelectorAll('[data-dg-buy], .dg-buy-btn, form[action*="/cart/add"] [type="submit"]').forEach(function (btn) {
        btn.classList.add('is-added');
        var label = btn.querySelector('.glow-btn__glass');
        var original = label ? label.textContent : '';
        if (label) label.textContent = 'Added';
        window.setTimeout(function () {
          btn.classList.remove('is-added');
          if (label && original) label.textContent = original;
        }, 1100);
      });
    }

    function pushCurrentVariantToBundle(variantId, qty) {
      var offer = findOfferByVariantId(variantId);
      var count = qty || 1;
      var titleEl = root.querySelector('[data-dg-sticky-title]');
      var mainImg = root.querySelector('[data-dg-main-image]');
      var productType = /balm/i.test((titleEl && titleEl.textContent) || '') ? 'balm' : 'oil';
      for (var i = 0; i < count; i++) {
        if (bundleItems.length >= BUNDLE_SIZE) break;
        if (offer) {
          addOfferToBundle(offer, true, true);
        } else {
          var scentFallback = titleEl ? titleEl.textContent.trim() : 'Added item';
          bundleItems.push({
            id: 'current-' + Date.now() + '-' + i,
            variantId: variantId,
            type: productType,
            typeLabel: offerTypeLabel(productType),
            scent: scentFallback,
            name: scentFallback,
            img: mainImg ? mainImg.src : '',
            price: unitPrice,
            alreadyInCart: true,
            isOriginal: true
          });
        }
      }
      renderBundle();
    }

    function onAddSuccess(variantId, qty) {
      flashAddedButtons();
      pushCurrentVariantToBundle(variantId, qty);
      openBundle();
      document.dispatchEvent(new CustomEvent('cart:update'));
    }

    if (productForm) {
      productForm.addEventListener(
        'submit',
        function (event) {
          if (!variantInput || !variantInput.value) return;
          /* Beat Dawn product-form.js so we open the bundle drawer, not the cart drawer */
          event.preventDefault();
          event.stopImmediatePropagation();

          var qtyInput = productForm.querySelector('input[name="quantity"]');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          var variantId = variantInput.value;

          addVariantToCartLocal(variantId, qty)
            .then(function () {
              onAddSuccess(variantId, qty);
            })
            .catch(function (err) {
              console.error('[CraftedDarkGlassPdp] cart add failed', err);
              productForm.submit();
            });
        },
        true
      );
    }

    if (bundleClose) bundleClose.addEventListener('click', closeBundle);
    if (bundleScrim) {
      bundleScrim.addEventListener('click', closeBundle);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && bundleDrawer.classList.contains('is-open')) closeBundle();
    });

    if (bundleCheckout) {
      bundleCheckout.addEventListener('click', function () {
        if (bundleItems.length < BUNDLE_SIZE) return;
        bundleCheckout.disabled = true;
        if (bundleSkip) bundleSkip.disabled = true;

        addPendingBundleItems()
          .then(function () {
            closeBundle();
            window.location.href = checkoutUrl();
          })
          .catch(function (err) {
            console.error('[CraftedDarkGlassPdp] bundle checkout failed', err);
            bundleCheckout.disabled = false;
            if (bundleSkip) bundleSkip.disabled = bundleItems.length < 1;
          });
      });
    }

    if (bundleSkip) {
      bundleSkip.addEventListener('click', function () {
        if (!bundleItems.length) return;
        bundleSkip.disabled = true;
        if (bundleCheckout) bundleCheckout.disabled = true;

        skipToOriginalCartOnly()
          .then(function () {
            window.location.href = cartPageUrl();
          })
          .catch(function (err) {
            console.error('[CraftedDarkGlassPdp] bundle skip failed', err);
            /* Still send them to cart with whatever is already there */
            window.location.href = cartPageUrl();
          });
      });
    }

    renderOffers();
    renderBundle();
  }

  function initBogoDrawer(root, productForm, variantInput) {
    var host = root.closest('product-info') || root.parentElement || document;
    var configNode = host.querySelector('[data-dg-bogo-config]');
    var cfg = {};
    if (configNode) {
      try {
        cfg = JSON.parse(configNode.textContent || '{}');
      } catch (e) {
        cfg = {};
      }
    }
    var offers = Array.isArray(cfg.offers) ? cfg.offers : [];
    if (!offers.length || !productForm || !variantInput) return;

    var drawer = host.querySelector('[data-dg-bogo-drawer]');
    var scrim = host.querySelector('[data-dg-bogo-scrim]');
    var scents = host.querySelector('[data-dg-bogo-scents]');
    var claimBtn = host.querySelector('[data-dg-bogo-claim]');
    var skipBtn = host.querySelector('[data-dg-bogo-skip]');
    var closeBtn = host.querySelector('[data-dg-bogo-close]');
    var errorEl = host.querySelector('[data-dg-bogo-error]');
    var softenerEl = host.querySelector('[data-dg-bogo-softener]');
    var totalEl = host.querySelector('[data-dg-bogo-total]');
    if (!drawer || !scents) return;

    var selectedId = String(offers[0].variantId);
    var busy = false;
    var lastFocus = null;

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function currentQty() {
      var qtyInput = productForm.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return qty > 0 ? qty : 1;
    }

    function softenerCents() {
      return (cfg.softenerPrice || 0) * currentQty();
    }

    function renderTotals() {
      var cents = softenerCents();
      if (softenerEl) softenerEl.textContent = moneyFromCents(cents);
      if (totalEl) totalEl.textContent = moneyFromCents(cents);
    }

    function setError(message) {
      if (!errorEl) return;
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function renderScents() {
      scents.innerHTML = '';
      offers.forEach(function (offer) {
        var btn = document.createElement('button');
        var id = String(offer.variantId);
        btn.type = 'button';
        btn.className = 'bundle-item glass glow-target' + (id === selectedId ? ' is-selected' : '');
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', id === selectedId ? 'true' : 'false');
        btn.innerHTML =
          (offer.image
            ? '<img src="' + escapeHtml(offer.image) + '" alt="" loading="lazy" decoding="async" />'
            : '') +
          '<strong>' +
          escapeHtml(offer.scent && offer.scent !== 'Default Title' ? offer.scent : 'Beard Oil') +
          '</strong>' +
          '<em><s>' +
          moneyFromCents(offer.price || 0) +
          '</s> Free</em>';
        btn.addEventListener('click', function () {
          selectedId = id;
          renderScents();
        });
        scents.appendChild(btn);
      });
    }

    function openDrawer() {
      lastFocus = document.activeElement;
      renderTotals();
      renderScents();
      setError('');
      if (scrim) {
        scrim.hidden = false;
        requestAnimationFrame(function () {
          scrim.classList.add('is-open');
        });
      }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var selected = scents.querySelector('.is-selected');
      if (selected) selected.focus();
    }

    function closeDrawer() {
      if (scrim) scrim.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (scrim) {
        window.setTimeout(function () {
          scrim.hidden = true;
        }, 320);
      }
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function setBusy(next) {
      busy = next;
      if (claimBtn) claimBtn.disabled = next;
      if (skipBtn) skipBtn.disabled = next;
    }

    function addItems(includeOil) {
      if (busy) return;
      if (!variantInput.value) return;
      var items = [{ id: Number(variantInput.value), quantity: currentQty() }];
      if (includeOil) {
        items.push({
          id: Number(selectedId),
          quantity: 1,
          properties: { Offer: 'Free with Beard Softener' }
        });
      }
      setBusy(true);
      setError('');
      fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: items,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              var message =
                (data && data.description) ||
                (data && data.message) ||
                'Could not add that to the cart. Try again.';
              throw new Error(message);
            }
            return data;
          });
        })
        .then(function (state) {
          setBusy(false);
          closeDrawer();
          if (!openThemeCartDrawer(state)) window.location.href = '/cart';
        })
        .catch(function (err) {
          setBusy(false);
          setError(err && err.message ? err.message : 'Could not add that to the cart. Try again.');
        });
    }

    productForm.addEventListener(
      'submit',
      function (event) {
        if (!variantInput.value) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        openDrawer();
      },
      true
    );

    if (claimBtn) {
      claimBtn.addEventListener('click', function () {
        addItems(true);
      });
    }
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        addItems(false);
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    renderScents();
    renderTotals();
  }

  function initOilContentInteractions() {
    var scope = document.querySelector('[data-dg-oil-root], .dg-oil-content, .dg-roller-content');
    if (!scope || scope.dataset.dgOilReady === 'true') return;
    scope.dataset.dgOilReady = 'true';

    var atcLabelPrefix = 'ADD TO CART';
    var chooseLabel = 'CHOOSE AN AVAILABLE SCENT';
    var variantsEl = scope.querySelector('[data-dg-oil-variants]');
    var variants = {};
    if (variantsEl) {
      try {
        variants = JSON.parse(variantsEl.textContent || '{}');
      } catch (e) {
        variants = {};
      }
    }

    function getMainForm() {
      return document.querySelector('.dg-pdp form[action*="/cart/add"], form.dg-product-form, product-form form');
    }

    function getVariantId() {
      var form = getMainForm();
      var input = form && form.querySelector('input[name="id"]');
      return input ? input.value : '';
    }

    function syncOilCtas(detail) {
      var variantId = (detail && detail.variantId) || getVariantId();
      var data = variants[variantId] || {};
      var available =
        detail && typeof detail.available === 'boolean'
          ? detail.available
          : data.available !== false;
      var price = (detail && detail.price) || data.price || '';
      var title = (detail && detail.title) || data.title || '';

      var priceEls = scope.querySelectorAll('[data-dg-oil-price]');
      priceEls.forEach(function (el) {
        if (price) el.textContent = price;
      });

      var titleEls = scope.querySelectorAll('[data-dg-oil-variant-title]');
      titleEls.forEach(function (el) {
        if (title && title !== 'Default Title') el.textContent = title;
        else if (!title) el.textContent = '';
      });

      var availEls = scope.querySelectorAll('[data-dg-oil-availability]');
      availEls.forEach(function (el) {
        el.textContent = available ? 'In stock' : 'Sold out';
        el.classList.toggle('dg-oil-avail--out', !available);
      });

      scope.querySelectorAll('[data-dg-oil-atc]').forEach(function (btn) {
        btn.setAttribute('data-dg-oil-available', available ? 'true' : 'false');
        if (available) btn.removeAttribute('data-dg-oil-choose-scent');
        else btn.setAttribute('data-dg-oil-choose-scent', '');
        var label = btn.querySelector('[data-dg-oil-atc-label]');
        if (label) {
          label.textContent = available && price ? atcLabelPrefix + ' — ' + price : chooseLabel;
        }
      });
    }

    function triggerMainAddToCart() {
      var form = getMainForm();
      if (!form) return;
      var submit = form.querySelector('[type="submit"], button[name="add"]');
      if (submit && !submit.disabled) submit.click();
    }

    scope.querySelectorAll('[data-dg-oil-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var available = btn.getAttribute('data-dg-oil-available') !== 'false';
        if (!available) {
          if (window.CraftedDarkGlassPdp && typeof window.CraftedDarkGlassPdp.focusVariantSelector === 'function') {
            window.CraftedDarkGlassPdp.focusVariantSelector();
          }
          return;
        }
        triggerMainAddToCart();
      });
    });

    scope.querySelectorAll('[data-dg-oil-back-options]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        if (window.CraftedDarkGlassPdp && typeof window.CraftedDarkGlassPdp.focusVariantSelector === 'function') {
          window.CraftedDarkGlassPdp.focusVariantSelector();
        } else {
          var buyBox = document.querySelector('#dgPdpBuyBox');
          if (buyBox) buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    document.addEventListener('dg:oil-variant-sync', function (event) {
      syncOilCtas(event.detail || {});
    });

    syncOilCtas({});

    /* Hide empty Judge.me review shell — keep visible when Crafted review cards exist */
    var reviewsShell = scope.querySelector('[data-dg-reviews-shell]');
    if (reviewsShell) {
      var widget = reviewsShell.querySelector('[data-dg-reviews-widget]');
      function maybeHideReviews() {
        if (!widget) {
          reviewsShell.hidden = true;
          reviewsShell.classList.add('is-empty');
          return;
        }
        var hasCrafted = widget.querySelector('.dg-jm__card, .dg-jm__summary, .dg-jm__list');
        var hasApp = widget.querySelector(
          '.shopify-app-block, [id*="judgeme"], .jdgm-rev-widg, .jdgm-widget, .jdgm-review-widget, .dg-jm'
        );
        var hasText = (widget.textContent || '').replace(/\s+/g, '').length > 40;
        if (hasCrafted) {
          reviewsShell.hidden = false;
          reviewsShell.classList.remove('is-empty');
          return;
        }
        if (!hasApp && !hasText) {
          reviewsShell.hidden = true;
          reviewsShell.classList.add('is-empty');
        }
      }
      window.setTimeout(maybeHideReviews, 400);
      window.setTimeout(maybeHideReviews, 1800);
    }
  }

  function initDgFaqLists() {
    document.querySelectorAll('.faq-list .dg-faq').forEach(function (item) {
      if (item.dataset.dgFaqBound === '1') return;
      var list = item.closest('.faq-list');
      if (!list) return;
      item.dataset.dgFaqBound = '1';
      item.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        list.querySelectorAll('.dg-faq').forEach(function (f) {
          f.classList.remove('is-open');
          f.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          item.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function truncateText(value, max) {
    var text = String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
    if (text.length <= max) return text;
    return text.slice(0, max - 1).replace(/\s+\S*$/, '') + '…';
  }

  function formatReviewDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return '';
    try {
      return date.toLocaleDateString(undefined, { month: 'short', day: '2-digit', year: 'numeric' });
    } catch (err) {
      return date.toISOString().slice(0, 10);
    }
  }

  function renderJmStars(rating) {
    var score = Math.round(Number(rating) || 0);
    var html = '';
    for (var i = 1; i <= 5; i += 1) {
      html +=
        '<span class="dg-jm__star' +
        (i <= score ? ' is-on' : '') +
        '" aria-hidden="true">★</span>';
    }
    return html;
  }

  function renderJmCard(review) {
    var rating = Number(review.rating) || 0;
    var name = review.reviewer_name || 'Verified buyer';
    var initial =
      review.reviewer_initial ||
      String(name).replace(/^\s+/, '').charAt(0).toUpperCase() ||
      'C';
    var body = review.body || (review.body_html ? String(review.body_html).replace(/<[^>]+>/g, ' ') : '');
    var dateLabel = formatReviewDate(review.created_at);
    var html =
      '<article class="dg-jm__card glass" data-rating="' +
      escapeHtml(rating) +
      '">' +
      '<header class="dg-jm__card-head">' +
      '<div class="dg-jm__avatar" aria-hidden="true">' +
      escapeHtml(initial) +
      '</div>' +
      '<div class="dg-jm__meta">' +
      '<div class="dg-jm__stars dg-jm__stars--sm" aria-label="' +
      escapeHtml(rating) +
      ' out of 5 stars" role="img">' +
      renderJmStars(rating) +
      '</div>' +
      '<p class="dg-jm__author">' +
      escapeHtml(name) +
      (review.verified_buyer ? '<span class="dg-jm__verified">Verified</span>' : '') +
      '</p>';
    if (dateLabel) {
      html +=
        '<time class="dg-jm__date" datetime="' +
        escapeHtml(review.created_at) +
        '">' +
        escapeHtml(dateLabel) +
        '</time>';
    }
    html += '</div></header>';
    if (review.title) {
      html += '<h3 class="dg-jm__title">' + escapeHtml(review.title) + '</h3>';
    }
    if (body) {
      html += '<p class="dg-jm__body">' + escapeHtml(truncateText(body, 420)) + '</p>';
    }
    if (review.reply_content) {
      html +=
        '<div class="dg-jm__reply"><strong>' +
        escapeHtml(review.shop_reply_name || 'Crafted Beards') +
        '</strong><p>' +
        escapeHtml(truncateText(String(review.reply_content).replace(/<[^>]+>/g, ' '), 280)) +
        '</p></div>';
    }
    html += '</article>';
    return html;
  }

  function initDgJmReviews(scope) {
    var roots = (scope || document).querySelectorAll('[data-dg-jm-root]');
    roots.forEach(function (root) {
      if (root.dataset.dgJmReady === 'true') return;
      var list = root.querySelector('[data-dg-jm-list]');
      var nav = root.querySelector('[data-dg-jm-nav]');
      var statusEl = root.querySelector('[data-dg-jm-status]');
      var toolbar = root.querySelector('[data-dg-jm-toolbar]');
      var filterLabel = root.querySelector('[data-dg-jm-filter-label]');
      var prevBtn = root.querySelector('[data-dg-jm-prev]');
      var nextBtn = root.querySelector('[data-dg-jm-next]');
      var clearBtn = root.querySelector('[data-dg-jm-clear]');
      var shopDomain = root.getAttribute('data-shop-domain');
      var productId = root.getAttribute('data-product-id');
      var productUrl = root.getAttribute('data-product-url');
      if (!list || !shopDomain || !productId || !productUrl) return;

      root.dataset.dgJmReady = 'true';

      var state = {
        page: 1,
        rating: null,
        perPage: Number(root.getAttribute('data-per-page') || 5) || 5,
        totalPages: Number(root.getAttribute('data-total-pages') || 1) || 1,
        totalReviews: Number(root.getAttribute('data-total-reviews') || 0) || 0,
        loading: false
      };

      function updateChrome() {
        if (nav) {
          nav.hidden = state.totalPages <= 1 && !state.rating;
        }
        if (prevBtn) prevBtn.disabled = state.loading || state.page <= 1;
        if (nextBtn) nextBtn.disabled = state.loading || state.page >= state.totalPages;
        if (statusEl) {
          if (state.totalPages < 1) {
            statusEl.textContent = 'No reviews';
          } else {
            statusEl.textContent = 'Page ' + state.page + ' of ' + state.totalPages;
          }
        }
        if (toolbar) {
          toolbar.hidden = !state.rating;
        }
        if (filterLabel && state.rating) {
          filterLabel.textContent = 'Showing ' + state.rating + '-star reviews';
        }
        root.querySelectorAll('[data-dg-jm-filter]').forEach(function (btn) {
          var active = String(btn.getAttribute('data-dg-jm-filter')) === String(state.rating || '');
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      function fetchPage() {
        if (state.loading) return Promise.resolve();
        state.loading = true;
        root.classList.add('is-loading');
        updateChrome();

        var params = new URLSearchParams({
          shop_domain: shopDomain,
          platform: 'shopify',
          page: String(state.page),
          per_page: String(state.perPage),
          url: productUrl,
          product_id: String(productId)
        });
        if (state.rating) params.set('filter_rating', String(state.rating));

        return fetch('https://judge.me/reviews/reviews_for_widget?' + params.toString(), {
          credentials: 'omit',
          mode: 'cors'
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Review fetch failed');
            return res.json();
          })
          .then(function (data) {
            var reviews = (data && data.reviews) || [];
            var pagination = (data && data.pagination) || {};
            state.totalPages = Number(pagination.total_pages || 0) || (reviews.length ? 1 : 0);
            state.page = Number(pagination.current_page || state.page) || state.page;
            if (state.totalPages > 0 && state.page > state.totalPages) {
              state.page = state.totalPages;
            }
            if (!reviews.length) {
              list.innerHTML =
                '<p class="dg-jm__empty">' +
                (state.rating
                  ? 'No ' + escapeHtml(state.rating) + '-star reviews yet.'
                  : 'No reviews to show.') +
                '</p>';
            } else {
              list.innerHTML = reviews.map(renderJmCard).join('');
            }
            if (nav) nav.hidden = false;
            try {
              var top = list.getBoundingClientRect().top;
              if (top < 80 || top > window.innerHeight * 0.55) {
                list.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            } catch (err) {}
          })
          .catch(function () {
            list.innerHTML =
              '<p class="dg-jm__empty">Couldn’t load more reviews. Please try again.</p>';
          })
          .then(function () {
            state.loading = false;
            root.classList.remove('is-loading');
            updateChrome();
          });
      }

      function setFilter(rating) {
        var next = rating ? Number(rating) : null;
        if (state.rating === next) next = null;
        state.rating = next;
        state.page = 1;
        fetchPage();
      }

      root.querySelectorAll('[data-dg-jm-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          setFilter(btn.getAttribute('data-dg-jm-filter'));
        });
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          setFilter(null);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          if (state.page <= 1) return;
          state.page -= 1;
          fetchPage();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (state.page >= state.totalPages) return;
          state.page += 1;
          fetchPage();
        });
      }

      updateChrome();
    });
  }

  /* Open Judge.me in-store write-review form from Crafted glow buttons */
  function initDgJmWriteReview(scope) {
    var roots = (scope || document).querySelectorAll('[data-dg-jm-root]');
    if (!roots.length && scope && scope.matches && scope.matches('[data-dg-jm-root]')) {
      roots = [scope];
    }

    function ensureWriteTrigger(root) {
      var productId = root.getAttribute('data-product-id') || '';
      var native =
        root.querySelector('#judgeme_product_reviews') ||
        document.getElementById('judgeme_product_reviews');
      var host = native || root;

      /* Prefer JM’s own write link inside the mount after setup */
      var jmLink =
        (native &&
          native.querySelector(
            'a.jdgm-write-rev-link:not([data-dg-jm-write]), .jdgm-write-rev-link:not(.dg-jm__write-trigger)'
          )) ||
        null;

      var trigger =
        jmLink ||
        host.querySelector('[data-dg-jm-write-trigger]') ||
        root.querySelector('[data-dg-jm-write-trigger]');

      if (!trigger) {
        trigger = document.createElement('a');
        trigger.href = '#judgeme_product_reviews';
        trigger.className = 'jdgm-write-rev-link dg-jm__write-trigger';
        trigger.setAttribute('data-dg-jm-write-trigger', '');
        trigger.textContent = 'Write a review';
        host.appendChild(trigger);
      } else if (native && !native.contains(trigger)) {
        native.appendChild(trigger);
      }

      if (productId) {
        trigger.setAttribute('data-id', productId);
        trigger.setAttribute('data-product-id', productId);
      }
      trigger.classList.add('jdgm-write-rev-link');
      return trigger;
    }

    function revealWriteModalFirstStep() {
      var modal =
        document.querySelector('.jdgm-write-review-modal') ||
        document.querySelector('[class*="jdgm-write-review-modal"]');
      if (!modal) return;

      modal.style.display = 'block';
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');

      var content = modal.querySelector('.jdgm-write-review-modal__content');
      if (content) {
        content.style.opacity = '1';
        content.style.visibility = 'visible';
        content.style.color = '#1a1612';
      }

      var pages = modal.querySelectorAll('.jdgm-write-review-modal__page');
      if (!pages.length) {
        pages = modal.querySelectorAll('[class*="write-review-modal__page"]');
      }
      if (!pages.length) return;

      var first = null;
      Array.prototype.forEach.call(pages, function (page, index) {
        var isIntro =
          page.classList.contains('jdgm-write-review-modal__page--review-form-intro') ||
          page.classList.contains('jdgm--visible') ||
          page.classList.contains('current-page');
        if (!first && (isIntro || index === 0)) first = page;
      });
      if (!first) first = pages[0];

      Array.prototype.forEach.call(pages, function (page) {
        if (page === first) {
          page.style.opacity = '1';
          page.style.visibility = 'visible';
          page.style.pointerEvents = 'auto';
          page.style.display = page.style.display === 'none' ? 'flex' : page.style.display;
          page.removeAttribute('hidden');
          page.setAttribute('aria-hidden', 'false');
          page.classList.add('jdgm--visible', 'current-page');

          var section = page.closest
            ? page.closest('.jdgm-write-review-modal__section')
            : page.parentElement;
          if (section && section.classList && section.classList.contains('jdgm-write-review-modal__section')) {
            section.style.opacity = '1';
            section.style.visibility = 'visible';
            section.style.pointerEvents = 'auto';
            section.classList.add('jdgm--visible');
          }
        }
      });
    }

    function openJudgeMeWriteForm(root) {
      var trigger = ensureWriteTrigger(root);
      if (!trigger) return false;

      try {
        if (typeof trigger.click === 'function') {
          trigger.click();
        } else {
          trigger.dispatchEvent(
            new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
          );
        }
      } catch (err) {
        trigger.dispatchEvent(
          new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
        );
      }

      /* JM animates steps after click — nudge first step if still blank */
      window.setTimeout(revealWriteModalFirstStep, 50);
      window.setTimeout(revealWriteModalFirstStep, 250);
      window.setTimeout(revealWriteModalFirstStep, 600);
      return true;
    }

    function bindRoot(root) {
      if (!root || root.dataset.dgJmWriteReady === 'true') return;
      root.dataset.dgJmWriteReady = 'true';
      ensureWriteTrigger(root);
      root.querySelectorAll('[data-dg-jm-write]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          openJudgeMeWriteForm(root);
        });
      });
    }

    Array.prototype.forEach.call(roots, bindRoot);

    if (!window.__dgJmWriteSetupBound) {
      window.__dgJmWriteSetupBound = true;
      document.addEventListener('jdgm.doneSetup', function () {
        document.querySelectorAll('[data-dg-jm-root]').forEach(ensureWriteTrigger);
      });
    }
  }

  window.CraftedDarkGlassPdp = window.CraftedDarkGlassPdp || {};
  window.CraftedDarkGlassPdp.init = initPdp;

  function headerGroupOffsetPx() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-group-height').trim();
    if (raw) {
      var n = parseFloat(raw);
      if (!isNaN(n)) {
        if (raw.indexOf('rem') !== -1) {
          var rootFs = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
          return n * rootFs + 16;
        }
        if (raw.indexOf('px') !== -1 || /^\d+(\.\d+)?$/.test(raw)) {
          return n + 16;
        }
      }
    }
    var header =
      document.querySelector('#shopify-section-header') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');
    var ann = document.querySelector('.announcement-bar, .dg-announce, #shopify-section-announcement-bar');
    var h = header ? header.getBoundingClientRect().height : 0;
    var a = ann ? ann.getBoundingClientRect().height : 0;
    return Math.max(72, h + a) + 16;
  }

  function scrollToReviewsTarget(id) {
    var el =
      (id && document.getElementById(id)) ||
      document.getElementById('reviews') ||
      document.querySelector('[data-dg-reviews-shell]');
    if (!el || el.hidden) return false;

    function applyScroll() {
      var offset = headerGroupOffsetPx();
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      // Instant scroll — smooth + mid-scroll layout shift was overshooting past #reviews
      window.scrollTo(0, Math.max(0, top));
      var delta = el.getBoundingClientRect().top - offset;
      if (Math.abs(delta) > 12) {
        window.scrollTo(0, Math.max(0, window.pageYOffset + delta));
      }
    }

    applyScroll();
    window.requestAnimationFrame(applyScroll);
    window.setTimeout(applyScroll, 120);
    window.setTimeout(applyScroll, 350);
    return true;
  }

  function initReviewsAnchorScroll() {
    if (window.__dgReviewsAnchorBound) return;
    window.__dgReviewsAnchorBound = true;

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target && event.target.closest ? event.target.closest('a[href="#reviews"]') : null;
        if (!link) return;
        if (link.closest('.jdgm-write-review-modal')) return;
        event.preventDefault();
        if (typeof event.stopPropagation === 'function') event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        if (scrollToReviewsTarget('reviews')) {
          if (history.replaceState) history.replaceState(null, '', '#reviews');
          else window.location.hash = 'reviews';
        }
      },
      true
    );

    function handleHash() {
      if (window.location.hash !== '#reviews') return;
      window.setTimeout(function () {
        scrollToReviewsTarget('reviews');
      }, 50);
    }

    window.addEventListener('hashchange', handleHash);
    handleHash();
  }

  onReady(function () {
    if (document.querySelector('.dg-pdp')) initPdp();
    initOilContentInteractions();
    initDgFaqLists();
    initDgJmReviews(document);
    initDgJmWriteReview(document);
    initReviewsAnchorScroll();
  });


  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.dg-pdp')) {
      var pdp = event.target.querySelector('.dg-pdp');
      if (pdp) pdp.dataset.dgInitialized = '';
      initPdp();
    }
    var oil =
      event.target.querySelector('[data-dg-oil-root], .dg-oil-content, .dg-roller-content') ||
      document.querySelector('[data-dg-oil-root], .dg-oil-content, .dg-roller-content');
    if (oil) oil.dataset.dgOilReady = '';
    initOilContentInteractions();
    initDgFaqLists();
    initDgJmReviews(event.target);
    initDgJmWriteReview(event.target);
  });
})();
